import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';

import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { Utils } from '@src/utils/util';
import { BackupsComponent } from './backups.component'
import { BackupsFilterComponent } from './backups-filter/backups-filter.component';
import { BackupsDataComponent } from './backups-data/backups-data.component'; 
import {HttpClientModule} from '@angular/common/http';

@NgModule({
    imports: [SharedModule, MatTableModule, MatSortModule, MatDatepickerModule, MatInputModule, MatNativeDateModule , HttpClientModule ],
    declarations: [BackupsComponent,BackupsDataComponent,BackupsFilterComponent],
    entryComponents: [BackupsComponent],
    exports: [BackupsComponent],
    providers: [MatDatepickerModule, MatNativeDateModule, Utils]
})
export class BuckupsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/buckups-ang7/backups.component.module.ts